import styled from 'styled-components';
import Badge, { BadgeProps } from 'antd/es/badge';

import BellIcon from '#/assets/BellIcon';

import { cCC38FF, cFFFFFF } from '#/colors';

import {
  useNotificationsDrawerActions,
  useNotificationsDrawerView,
} from '#/features/notifications/drawer-context';
import { useNotificationsView } from '#/features/notifications/notifications-context';

interface Props {
  readonly className?: string;
}

export default function NotificationsButton(props: Props) {
  const { className } = props;
  const drawerActions = useNotificationsDrawerActions();
  const drawerView = useNotificationsDrawerView();
  const notificationsView = useNotificationsView();

  return (
    <UnseenBadge dot={notificationsView.hasUnseen} className={className}>
      <Button isActive={drawerView.isOpen} onClick={drawerActions.toggle}>
        <BellIcon />
      </Button>
    </UnseenBadge>
  );
}

interface ButtonProps {
  isActive: boolean;
}

const PADDING_TOP = 5;

const Button = styled.button.attrs({
  'aria-label': 'Notification Center',
})<ButtonProps>`
  height: 100%;
  display: grid;
  place-items: center;
  padding: 5px;
  padding-top: ${PADDING_TOP}px;
  margin: 0 -5px;
  background: none;
  border: none;
  color: ${cFFFFFF};
  opacity: ${({ isActive }) => (isActive ? '1.0' : '0.5')};

  &:hover {
    opacity: 0.7;
  }
`;

const UnseenBadge = styled(
  ({ className, dot = false, ...rest }: BadgeProps) => (
    <Badge
      dot={dot}
      aria-label={dot ? 'new notifications available' : 'no new notifications'}
      offset={[-3, 3 + PADDING_TOP]}
      color={cCC38FF}
      rootClassName={className}
      {...rest}
    />
  ),
)`
  .ant-badge-dot {
    box-shadow: none;
  }
`;
